import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { connect } from 'react-redux';

import ThreeEssentailsButton from '../three-essentails-button/three-essentails-button';
import ConsoleModalContext from '../../containers/console/context/console-modal-context';
import OrganiseClassGroupsModal from './components/organise-class-groups-modal/organise-class-groups-modal';
import { PRODUCT_IDS } from '../../helpers/enums';

const OneRosterOrganiseClassGroups = ({
    createMultiYearGroups,
    classroomId,
    updateCurrentClassId,
    hasContentLoaded,
    resetMultiYearGroupFetch,
    isMultiLevelGroupsCreated,
    isGroupModal
}) => {
    const { setShowConsoleModal, setConsoleModalContent } = useContext(ConsoleModalContext);

    const closeOrganiseClassGroupsModal = () => {
        setShowConsoleModal(false);
    };

    const clickHandler = async () => {
        window.scroll(0, 0);
        await createMultiYearGroups({ classId: classroomId });
        await updateCurrentClassId({ productId: PRODUCT_IDS.Mathletics, classId: classroomId });
    };

    useEffect(() => {
        if (isMultiLevelGroupsCreated) {
            closeOrganiseClassGroupsModal(true);
        }
    }, [isMultiLevelGroupsCreated]);

    const showOrganiseClassGroupsModal = () => {
        setShowConsoleModal(true);
        resetMultiYearGroupFetch();

        setConsoleModalContent(
            <OrganiseClassGroupsModal
                classroomId={classroomId}
                clickHandler={clickHandler}
                title={<Trans id="One Roster - Organise Class Groups - Modal Header" />}
                description={<Trans id="One Roster - Organise Class Groups - Modal Body" />}
                closeHandler={closeOrganiseClassGroupsModal}
                hasContentLoaded={hasContentLoaded}
                isMultiLevelGroupsCreated={isMultiLevelGroupsCreated}
            />
        );
    };

    return (
        <div className="groups__button-container">
            <ThreeEssentailsButton
                clickHandler={showOrganiseClassGroupsModal}
                title={<Trans id="One Roster - Organise class groups" />}
                show3EIcon={false}
                buttonClassName={`${isGroupModal ? 'edit_group_name_autoselect' : 'edit_group_name'}`}
                showArrow={false}
            />
        </div>
    );
};

OneRosterOrganiseClassGroups.propTypes = {
    createMultiYearGroups: PropTypes.func.isRequired,
    classroomId: PropTypes.number.isRequired,
    updateCurrentClassId: PropTypes.func.isRequired,
    resetMultiYearGroupFetch: PropTypes.func.isRequired,
    hasContentLoaded: PropTypes.bool,
    isMultiLevelGroupsCreated: PropTypes.bool,
    isGroupModal: PropTypes.bool
};

const mapStateToProps = (state) => {
    const { isMultiLevelGroupsCreated } = state.consoleReducer;

    return {
        isMultiLevelGroupsCreated
    };
};

export default connect(mapStateToProps)(OneRosterOrganiseClassGroups);



// WEBPACK FOOTER //
// ./components/one-roster-organise-class-groups/one-roster-organise-class-groups.js